// Compatibilité : SITE_URL vient désormais de la SOURCE UNIQUE (routes-meta.js).
import { SITE_URL } from "../seo/routes-meta";

export { SITE_URL };

// Routes éditables dans le panneau SEO de l'admin (surcharges de contenu).
export const SEO_ROUTES = [
  { key: "/", label: "Accueil" },
  { key: "/pilote", label: "Pilote" },
  { key: "/audit", label: "Audit" },
  { key: "/agences", label: "Agences" },
  { key: "/o", label: "Pages secteurs (/o)" },
  { key: "/legal", label: "Pages légales" },
];
